export interface WardStatsModuleProps {
  avg: number;
  stealth: number;
  farsight: number;
  control: number;
}

interface WardModuleProps {
  ward: string;
  value: number;
}
export function WardModule(props: WardModuleProps) {
  const { ward, value } = props;
  const imageUrl = `https://static.bigbrain.gg/assets/lol/icons/icon_ward_${ward}.png`;
  const backgroundStyle = {
    backgroundImage: `url('${imageUrl}')`,
  };

  const formattedNumber = value.toLocaleString("en-US");
  return (
    <div className="flex flex-col items-center">
      <img src={imageUrl} alt={`${ward} Ward Icon`} className="w-16 h-16 shrink-0 bg-cover bg-center rounded-lg" />
      <div className="text-white text-center font-barlow text-4xl font-medium uppercase mt-3 mb-[6px]">{formattedNumber}</div>
      <div className="text-[#CDDCFE] text-center font-barlow text-sm font-medium">{ward}</div>
    </div>
  );
}

export function WardStatsModule(props: WardStatsModuleProps) {
  const { avg, stealth, farsight, control } = props;

  return (
    <div className="flex flex-col gap-12 items-center">
      <div className="w-[239px] h-[81px] z-0 bg-[linear-gradient(179deg,rgba(50,115,250,0.10)_0.48%,rgba(50,115,250,0.00)_99.49%)] border-t border-solid border-[#3273FA] border-t-1">
        <div className="flex flex-col items-center gap-[3px]">
          <div className="text-white text-center font-barlow text-[36px] font-medium uppercase mt-[5px]">{avg}</div>
          <div className="text-[#CDDCFE] text-center font-barlow text-sm font-medium">Average Vision Score</div>
        </div>
      </div>
      <div className="flex justify-center gap-12">
        <WardModule ward="Stealth" value={stealth} />
        <WardModule ward="Farsight" value={farsight} />
        <WardModule ward="Control" value={control} />
      </div>
    </div>
  );
}
